module.exports = __webpack_public_path__ + "static/media/logo-horizontal-2.feafa5fa.png";